<template>
  <router-link
    :to="link"
    class="population-table-record-cell flex w-full h-full items-center"
  >
    {{ params.value?.val }}
  </router-link>
</template>

<script setup lang="ts">
import { ICellRendererParams } from '@ag-grid-community/core';
import { computed } from 'vue';

type RecordCellValue = {
  val: unknown;
  recordId: string;
  sourceId?: number;
  dataType?: string | null;
};

const { params } = defineProps<{
  params: ICellRendererParams<unknown, RecordCellValue>;
}>();

const link = computed(() => ({
  name: 'individual_record',
  params: {
    source_id: params.value?.sourceId,
    source_primary_key: params.value?.recordId,
  },
}));
</script>

<style lang="pcss" scoped>
@reference "../../css/theme.css";
.population-table-record-cell:focus-visible {
  @apply rounded-4 outline-none;
  box-shadow: inset 0 0 0 2px theme(colors.neutral-border-focus);
}
</style>
